module.exports = __webpack_public_path__ + "media/images/service/b_6-2deda4ac8509a81dc9584b43ea6f6403.png";